import './back-link.scss';

import { LeftOutlined } from '@/media/antd-icons';

import { LocalizedLink } from '../localized-link';

interface IProps {
  /** Путь из `ROUTES`, куда возвращает ссылка. */
  to: string;
  children: string;
}

/** Возврат на родительский экран: стрелка и название родителя. */
const BackLink: React.FC<IProps> = ({ to, children }) => {
  return (
    <LocalizedLink to={to} className="back-link">
      <LeftOutlined className="back-link__icon" />
      {children}
    </LocalizedLink>
  );
};

export default BackLink;
